import { COLORS } from 'shared/constants/theme';
import themeFactory from '../helpers/themeFactory';

export default themeFactory({
  backgroundColor: COLORS.amaranth,
  borderColor: COLORS.amaranth,
  color: COLORS.white,
  textDecoration: 'none'
});
